module.exports = __webpack_public_path__ + "media/mâi kâo jai loie jing jing loie.ba2dd109.mp3";